export enum CHATS {
    PAGE_TITLE = 'GLOBAL.CHATS',
}
